import React from 'react';
import { useMutation } from '@tanstack/react-query';
import {
  ProfileWidget,
  RequestsWidget,
  VacationBalanceWidget,
  TimeOffWidget,
  AttendanceWidget,
  DocumentsWidget,
  OrganisationWidget,
  QuarterlyBonusWidget,
} from '../../components/Widgets';
import { getImpersonateUsers, getAuthUser } from '../../utils/auth.util';
import { changeEmployee } from '../../store/apis/userService';
import { ImpersonateTabs, SpinnerLoading } from '../../components/Common';

import './Dashboard.scss';

function Dashboard() {
  document.title = 'Dashboard | Envision Daikin';

  const changeEmployeeMutation = useMutation({
    mutationFn: changeEmployee,
  });

  return (
    <div
      className="page-content"
      style={{
        paddingBottom: '0.5rem',
        marginTop: '-0.7rem',
        backgroundColor: '#EAECF0',
      }}
    >
      {getAuthUser()?.canViewOtherEmp && (
        <ImpersonateTabs
          users={getImpersonateUsers()}
          changeEmployeeMutation={changeEmployeeMutation}
        />
      )}
      <div className="grid-container">
        {changeEmployeeMutation?.isPending ? (
          <SpinnerLoading spinnerSize="2rem" height="85vh" width="85vw" />
        ) : (
          <>
            <RequestsWidget />
            <ProfileWidget />
            <QuarterlyBonusWidget />
            <VacationBalanceWidget />
            <AttendanceWidget />
            <TimeOffWidget />
            <DocumentsWidget />
            <OrganisationWidget />
          </>
        )}
      </div>
    </div>
  );
}

export default Dashboard;
